"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiSupplierExtraFieldResponseDto = void 0;
const class_transformer_1 = require("class-transformer");
const billing_api_supplier_extra_field_dto_1 = require("./billing-api-supplier-extra-field.dto");
/**
 * Расширенная, специфичная для конкретного мерчант-провайдера
 * информация о поставщике в формате ключ=значение.
 */
let BillingApiSupplierExtraFieldResponseDto = class BillingApiSupplierExtraFieldResponseDto extends billing_api_supplier_extra_field_dto_1.BillingApiSupplierExtraFieldDto {};
BillingApiSupplierExtraFieldResponseDto = __decorate([(0, class_transformer_1.Exclude)()], BillingApiSupplierExtraFieldResponseDto);
exports.BillingApiSupplierExtraFieldResponseDto = BillingApiSupplierExtraFieldResponseDto;
